export const SITE_LAYOUT_HEADER_HEIGHT_DESKTOP_PX = 150

export const SITE_LAYOUT_HEADER_HEIGHT_MOBILE_PX = 100

/**
 * Must match `Navigation` AppShell `header.height` and desktop `useMediaQuery`.
 */
export const SITE_LAYOUT_HEADER_DESKTOP_MEDIA_QUERY =
   '(min-width: 768px)'

export function getSiteLayoutHeaderHeightPx(): number {
   if (typeof window === 'undefined') {
      return SITE_LAYOUT_HEADER_HEIGHT_DESKTOP_PX
   }
   return window.matchMedia(SITE_LAYOUT_HEADER_DESKTOP_MEDIA_QUERY)
      .matches
      ? SITE_LAYOUT_HEADER_HEIGHT_DESKTOP_PX
      : SITE_LAYOUT_HEADER_HEIGHT_MOBILE_PX
}
